import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageContainer from "../Layout/PageContainer";
import StorageTypeForm from "./PromoCodeForm";
import promoCodeService from "../../redux/services/promoCodes.service";
import PromoCodeForm from "./PromoCodeForm";
toast.configure();

const PromoCode = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [promoCode, setPromoCode] = useState({});

  useEffect(() => {
    if (!/\d+/.test(id)) {
      navigate("/promoCodes/add");
    }
  }, [id, navigate]);

  useEffect(() => {
    if (props.currentUser.roleId === 2) {
      navigate("/dashboard");
    }
  }, [props.currentUser, navigate]);

  const getPromoCode = (id) => {
    promoCodeService
      .get(id)
      .then((response) => {
        setPromoCode(response.data.promoCodeInfo);
      })
      .catch((error) => {
        toast(error, {
          transition: Slide,
          closeButton: true,
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
      });
  };

  useEffect(() => {
    if (id != "" && /\d+/.test(id)) getPromoCode(id);
  }, [id]);

  return (
    <PageContainer
      pageTitleIcon="pe-7s-tools icon-gradient bg-plum-plate"
      pageHeading={
        id != "" && /\d+/.test(id) ? "Edit Promo Code" : "Add Promo Code"
      }
      pageSubTitle={
        id != "" && /\d+/.test(id)
          ? "Edit Promo Code information"
          : "Save Promo Code information"
      }
    >
      <PromoCodeForm promoCode={promoCode} />
    </PageContainer>
  );
};

export default PromoCode;
